{
  "id": 30,
  "location": "paris",
  "difficulty": "hard",
  "moves": 19,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "mud" },
    { "type": "collect", "kind": "croissant", "count": 28 }
  ],
  "stars": [3800, 5100],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . X . . X . .",
    ". . . . . . . .",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.53, "movesLeft": 4.2, "closeLosses": 0.31, "target": 0.52 }
}
